export const BASE_HREF_CONSTANTS: Record<string, string> = {
   acquireNew: '/acquire-new/postpaid/common/prepaid-to-postpaid',
   newConnection: '/new-connection/postpaid-sim',
};

const getUrlWithoutSlash = (url = ''): string => {
   return url?.split('/')?.join('');
};

export const getBaseHref = () => {
   for (const key in BASE_HREF_CONSTANTS) {
      const baseHref: string = getUrlWithoutSlash(BASE_HREF_CONSTANTS[key]);
      if (getUrlWithoutSlash(window.location.pathname).includes(baseHref)) {
         return BASE_HREF_CONSTANTS[key];
      }
   }

   return BASE_HREF_CONSTANTS.acquireNew;
};

export const isNewConnectionRoute = () => {
   const baseHref = getUrlWithoutSlash(BASE_HREF_CONSTANTS.newConnection);

   return getUrlWithoutSlash(window.location.pathname).includes(baseHref);
};
